/* global VERBOSE */

const verboseWrapper = (func, explicitName) => (...args) => {
  // eslint-disable-next-line no-console
  console.verbose(
    `wix-dataset ${explicitName} was called with ${JSON.stringify(args)}`
  )
  try {
    const result = func(...args)
    // eslint-disable-next-line no-console
    console.verbose(
      `wix-dataset ${explicitName} response ${JSON.stringify(result)}`
    )
    return result
  } catch (e) {
    // eslint-disable-next-line no-console
    console.verbose(`wix-dataset ${explicitName} response ${e}`)
    throw e
  }
}

const verboseIfNeeded = (func, explicitName) =>
  VERBOSE ? verboseWrapper(func, explicitName) : func

module.exports.verboseWrapper = verboseWrapper
module.exports.verboseIfNeeded = verboseIfNeeded



// WEBPACK FOOTER //
// ./dataset-controller/verboseWrapper.js